import drawPendant from './modules/draw-pendant';
import materialReward from './modules/material_reward';
import news from './modules/news';
import membershipSystem from './modules/membership-system';
import activityTemplate from './modules/activity-template';

export default {
	namespaced: true,
	state: () => ({}),
	mutation: {},
	actions: {},
	getters: {},

	modules: {
		drawPendant,
		materialReward,
		news,
		membershipSystem,
		activityTemplate,
	},
};



// WEBPACK FOOTER //
// ./src/store/ActivityPage/index.js